<fw-dialog title="Register New DICOM Peer" width="extra-small" [showClose]="true">
  <fw-dialog-content>
    <form [formGroup]="form">
      <mat-form-field appearance="outline">
        <mat-label>AE Title</mat-label>
        <input formControlName="aet" matInput name="aet" test-id="aet" />
        @if (form.get('aet').hasError('required')) {
          <mat-error>AE Title is required</mat-error>
        }
        @if (form.get('aet').hasError('maxlength')) {
          <mat-error>AE Title must be 16 characters or fewer</mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>IP/Hostname</mat-label>
        <input formControlName="host" matInput name="host" test-id="host" />
        <mat-error>IP/Hostname is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Port</mat-label>
        <input formControlName="port" matInput name="port" test-id="port" type="number" />
        <mat-error>Port is required</mat-error>
      </mat-form-field>
    </form>
    @if (ranConnectionTest) {
      <div class="connection-test-result" test-id="test-result">
        @if (connectionTestPass) {
          <p class="green">{{ connectionTestMsg }}</p>
        }
        @if (!connectionTestPass) {
          <p class="red">{{ connectionTestMsg }}</p>
        }
      </div>
    }
  </fw-dialog-content>

  <fw-dialog-actions>
    <fw-button
      test-id="test-connection"
      [disabled]="!canTestConnection()"
      [variant]="showSpinner ? 'progress' : 'outline'"
      (click)="testConnection()"
    >
      Test Connection
    </fw-button>
    <fw-button data-id="device-modal-close" test-id="close" variant="outline" (click)="closeDialog()">
      Close
    </fw-button>
    <fw-button data-id="device-modal-add" test-id="add" [disabled]="form.invalid" (click)="addPeer()"> Add </fw-button>
  </fw-dialog-actions>
</fw-dialog>
